module.exports = __webpack_public_path__ + "gfx/PCU-3_01.png";